import { render, staticRenderFns } from "./ICheckContactBlock.vue?vue&type=template&id=c2eb734a&scoped=true&"
import script from "./ICheckContactBlock.vue?vue&type=script&lang=ts&"
export * from "./ICheckContactBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ICheckContactBlock.vue?vue&type=style&index=0&id=c2eb734a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eb734a",
  null
  
)

export default component.exports